<template>
  <div class="skip-process-page">
    <div class="page-search-block">
      <!-- <span class="w-90 inline-block align-r m-r-8">高级筛选：</span> -->
      <div class="inline-block">
        <span class="w-90 inline-block align-r m-r-8">所属区域：</span>
        <AreaCascader v-model="filters.search.location" checkStrictly :end-level="2" placeholder="请输入"></AreaCascader>
      </div>
      <el-button class="submit-btn m-l-10" size="large" type="primary" @click="handleSearch">搜 索</el-button>
    </div>

    <div class="page-operate-block">
      <span class="tit">配置项</span>
      <div>
        <el-button
          class="operate-btn"
          @click="addRow"
          >新增</el-button
        >
        <!-- <el-button
          class="operate-btn"
          @click="editRow"
          :disabled="options.selection.length != 1"
          >编辑</el-button
        > -->
        <el-button
          class="operate-btn"
          @click="handleDeleteRow"
          :disabled="options.selection.length == 0"
          >批量删除</el-button
        >
        <!-- <el-button
          v-permission="'add'"
          class="operate-btn"
          @click="addRow"
          >新增</el-button
        >
        <el-button
          v-permission="'update'"
          class="operate-btn"
          @click="editRow"
          :disabled="options.selection.length != 1"
          >编辑</el-button
        >
        <el-button
          v-permission="'delete'"
          class="operate-btn"
          @click="handleDeleteRow"
          :disabled="options.selection.length == 0"
          >批量删除</el-button
        > -->
      </div>
    </div>

    <div class="table-list-block">
      <RTable
        :ref="tableVarity"
        :columns="tableColumn"
        :dataSource="tableData"
        :options="options"
        :pagination="pagination"
        @current-change="handlePageChange"
        @row-click="handleRowClick"
      >
        <el-table-column prop="province" label="省" min-width="100px"></el-table-column>
        <el-table-column prop="city" label="市" min-width="150px"></el-table-column>
        <el-table-column prop="region" label="区（县）" min-width="150px"></el-table-column>
        <el-table-column prop="houseReviewStatus" label="房源审核" min-width="100px">
          <template #default="scope">
            <div @click.stop>
              <el-switch
                @change="handlerChangeStatus(scope.row)"
                v-model="scope.row.houseReviewStatus"
                active-text="审核"
                :active-value="1"
                inactive-text="不审核"
                :inactive-value="2"
              >
              </el-switch>
            </div>
          </template>
        </el-table-column>
        <el-table-column prop="serviceFeeStatus" label="服务费" min-width="100px">
          <template #default="scope">
            <div @click.stop>
              <el-switch
                @change="handlerChangeStatus(scope.row)"
                v-model="scope.row.serviceFeeStatus"
                active-text="开启"
                :active-value="1"
                inactive-text="禁用"
                :inactive-value="2"
              >
              </el-switch>
            </div>
          </template>
        </el-table-column>
        <!-- <el-table-column prop="managerReviewStatus" label="经营者审核" min-width="100px">
          <template #default="scope">
            <div @click.stop>
              <el-switch
                @change="handlerChangeStatus(scope.row)"
                v-model="scope.row.managerReviewStatus"
                active-text="审核"
                :active-value="1"
                inactive-text="不审核"
                :inactive-value="2"
              >
              </el-switch>
            </div>
          </template>
        </el-table-column> -->
        <!-- <el-table-column prop="healthUploadStatus" label="防疫资料" min-width="100px">
          <template #default="scope">
            <div @click.stop>
              <el-switch
                @change="handlerChangeStatus(scope.row)"
                v-model="scope.row.healthUploadStatus"
                active-text="需要"
                :active-value="1"
                inactive-text="不需要"
                :inactive-value="2"
              >
              </el-switch>
            </div>
          </template>
        </el-table-column> -->
      </RTable>
    </div>

    <RModal customClass="manager-modal" :title="detailType == 'add' ? '新增' : '编辑'" :show="detailModal" :closeOnClick="false" width="640px" @change="detailModal = false" @close="detailModal = false">
      <template #content>
        <EditContent :show="detailModal" :config-info="curInfo" @close="detailModal = false" @success="getQuery" />
      </template>
    </RModal>
  </div>
</template>

<script>
import RModal from '@/components/common/RModal'
import RTable from '@/components/common/RTable'
import checkMix from '@/components/common/checkAll.js'
import tableMix from '@/components/common/tableListMixin.js'

import EditContent from './editContent.vue'
import AreaCascader from '@/components/common/areaCascader'

export default {
  mixins: [tableMix, checkMix],
  components: { RModal, RTable, EditContent, AreaCascader },

  data() {
    return {
      nowIsInit: false, // 当前正在初始化

      perms: [],
      curInfo: {},
      detailType: 'add',
      detailModal: false,

      tableVarity: '',
      tableData: [],
      tableColumn: [],
      options: {
        multiSelect: true, // 多选
        serialNum: false, // 显示序号
        loading: false, // 加载中状态
        initTable: true, // 是否一挂载就加载数据
        mutiSelect: true,
        selection: [],
      },
      pagination: {
        total: 0,
        pageIndex: 1,
        pageSize: 20,
      },

      filters: {
        search: {
          location: [],
        },
      },
    }
  },
  created() {
    this.perms = 'perms' in localStorage && localStorage.perms !== '' ? JSON.parse(localStorage.perms) : []
    this.getQuery()
  },
  methods: {
    // 获取查询参数
    getQueryParams() {
      let loc = this.filters.search.location || []
      let params = {
        areaCode: loc[2] || loc[1] || loc[0] || '',
        pageNumber: this.pagination.pageIndex,
        pageSize: this.pagination.pageSize,
      }

      if (!params.areaCode) delete params.areaCode

      return params
    },
    // 查询列表数据
    getQuery() {
      this.options.loading = true
      let params = this.getQueryParams()

      let url = 'SYSTEM.CONFIG.GET_LIST'
      this.nowIsInit = true
      this.fetchData({ url, method: 'get', params })
        .then((res) => {

          if (!res || !res.data) {
            this.tableData = []
            this.pagination.total = 0
          } else {
            for (let i = 0; i < res.data.length; i++) {
              if (res.data[i].provinceCode === '000000000000') {
                res.data[i].province = '全国'
                res.data[i].city = ''
                res.data[i].region = ''
                break
              }
            }
            this.tableData = res.data || []
            this.pagination.total = +res.count || 0
          }
        })
        .finally(() => {
          this.options.loading = false
          this.$nextTick(() => {
            this.nowIsInit = false
          })
        })
    },
    // 处理状态变更
    handlerChangeStatus(row) {
      if (this.nowIsInit) {
        return
      }

      let url = 'SYSTEM.CONFIG.POST_SAVE_OR_UPDATE'
      let params = {
        id: '',
        houseReviewStatus: '1',
        // managerReviewStatus: '1',
        healthUploadStatus: '1',
        serviceFeeStatus: '1',
      }
      for (let i in params) {
        params[i] = row[i]
      }

      this.fetchData({ url, method: 'post', params, flag: true, headers: { "Content-Type": "application/json" } }).then((res) => {
        if (res.code == 200) {
          this.$message.success('修改成功！')
        } else {
          this.$message.error(res.msg || '修改失败！')
        }
      }).catch((err) => {
        this.$message.error(err || '修改失败！')
      })
    },
    // 处理删除
    handleDeleteRow() {
      this.$confirm('确定删除当前选中的（' + this.options.selection.length + '条记录）信息吗？', {
        type: 'warning',
      }).then(() => {
        this.handleDelete()
      })
    },
    // 确认删除
    handleDelete() {
      let url = 'SYSTEM.CONFIG.POST_DELETE_BY_IDS'
      let params = this.options.selection.map((item) => item.id)

      this.fetchData({ url, method: 'post', params, headers: { "Content-Type": "application/json" }, flag: true })
        .then((res) => {
          if (res.code == 200) {
            this.$message.success('删除成功！')
            this.pagination.pageIndex = 1
            this.getQuery()
          } else {
            this.$message.error(res.msg || '删除失败！')
          }
        })
        .catch((err) => {
          this.$message.error(err || '删除失败！')
        })
    },
    // 新增一条记录
    addRow() {
      this.curInfo = {}
      this.detailModal = true
    },
    // 编辑记录
    editRow() {
      this.curInfo = this.options.selection[0]
      this.detailModal = true
    },
  },
}
</script>

<style lang="less" scoped>
.skip-process-page {
  .page-search-block .el-form-item {
    width: 380px;
    margin-right: 20px;
  }
  .width-100 {
    width: 100%;
    /deep/ .el-input {
      width: 100%;
    }
  }
}
</style>
